function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
import { Injectable, NgModule } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApolloLink, Observable } from 'apollo-link';
import { print } from 'graphql';
import { prioritize, mergeHeaders, fetch } from 'apollo-angular-link-http-common';
import { extractFiles } from 'extract-files';

// XXX find a better name for it
var HttpLinkHandler = /*#__PURE__*/function (_ApolloLink) {
  _inherits(HttpLinkHandler, _ApolloLink);
  var _super = _createSuper(HttpLinkHandler);
  function HttpLinkHandler(httpClient, options) {
    var _this;
    _classCallCheck(this, HttpLinkHandler);
    _this = _super.call(this);
    _this.httpClient = httpClient;
    _this.options = options;
    _this.requester = function (operation) {
      return new Observable(function (observer) {
        var context = operation.getContext();
        // decides which value to pick, Context, Options or to just use the default
        var pick = function pick(key, init) {
          return prioritize(context[key], _this.options[key], init);
        };
        var includeQuery = pick('includeQuery', true);
        var includeExtensions = pick('includeExtensions', false);
        var method = pick('method', 'POST');
        var url = pick('uri', 'graphql');
        var withCredentials = pick('withCredentials');
        var useMultipart = pick('useMultipart');
        var req = {
          method: method,
          url: typeof url === 'function' ? url(operation) : url,
          body: {
            operationName: operation.operationName,
            variables: operation.variables
          },
          options: {
            withCredentials: withCredentials,
            useMultipart: useMultipart,
            headers: _this.options.headers
          }
        };
        if (includeExtensions) {
          req.body.extensions = operation.extensions;
        }
        if (includeQuery) {
          req.body.query = print(operation.query);
        }
        if (context.headers) {
          req.options.headers = mergeHeaders(req.options.headers, context.headers);
        }
        var sub = fetch(req, _this.httpClient, extractFiles).subscribe({
          next: function next(response) {
            operation.setContext({
              response: response
            });
            observer.next(response.body);
          },
          error: function error(err) {
            return observer.error(err);
          },
          complete: function complete() {
            return observer.complete();
          }
        });
        return function () {
          if (!sub.closed) {
            sub.unsubscribe();
          }
        };
      });
    };
    return _this;
  }
  _createClass(HttpLinkHandler, [{
    key: "request",
    value: function request(op) {
      return this.requester(op);
    }
  }]);
  return HttpLinkHandler;
}(ApolloLink);
var HttpLink = /*#__PURE__*/function () {
  function HttpLink(httpClient) {
    _classCallCheck(this, HttpLink);
    this.httpClient = httpClient;
  }
  _createClass(HttpLink, [{
    key: "create",
    value: function create(options) {
      return new HttpLinkHandler(this.httpClient, options);
    }
  }]);
  return HttpLink;
}();
HttpLink.decorators = [{
  type: Injectable
}];
HttpLink.ctorParameters = function () {
  return [{
    type: HttpClient
  }];
};
var PROVIDERS = [HttpLink];
var HttpLinkModule = /*#__PURE__*/_createClass(function HttpLinkModule() {
  _classCallCheck(this, HttpLinkModule);
});
HttpLinkModule.decorators = [{
  type: NgModule,
  args: [{
    providers: PROVIDERS
  }]
}];

/**
 * Generated bundle index. Do not edit.
 */

export { HttpLink, HttpLinkHandler, HttpLinkModule, PROVIDERS };